import * as React from 'react'

interface Props {
    level: 'info' | 'warning'
    children: React.ReactNode
}

export class Alert extends React.Component<Props> {
    public render = () => <div className={'tw-m-0 alert alert-' + this.props.level}>{this.props.children}</div>
}
